import React from "react";
import { Button } from "semantic-ui-react";
import { genrateDV1FormPDF } from "../api/getESForm";
import { showToast } from "../util/showToast";

const Dv1Generation = () => {  

  const genratePdf=async()=>{
    const response=await genrateDV1FormPDF()
    const url=response?.data?.eventMessage?.url
    if(url){
     const pdfWindow = window.open()
     pdfWindow.location.href =url
    }
    else
    showToast('DV1 PDF generation Failed')
  }
  return (
     <Button size='mini'  className='sv todo-button primaryBtn'  onClick={genratePdf}
      >
        GENERATE DV1 FORM
     </Button>

  )
}

export default Dv1Generation
